<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="672px" :before-close="closeModal">
    <div class="d-flex flex-column justify-content-center align-items-center">
        <div :class="`mb-4 mt-5 border bdc-${getPrimaryColor}two icon-circle icon-file`">
            <FileWithWrite :size = "'24px'" :color="getPrimaryColorHex.four"/>
        </div>
        <h3 class="c-ndarkthree bold text-center mb-2">
            {{ changePartnerProfile ? 'Alterar o perfil do sócio' : 'Qual o perfil do sócio?' }}
        </h3>
        <p class="c-ndarkfour text-center" v-if="!changePartnerProfile">
            Selecione abaixo qual o perfil do sócio a ser cadastrado
        </p>
        <p class="c-ndarkfour text-center" v-else>
            Selecione abaixo qual perfil atribuir ao sócio <b>{{ $store.state.register.partner.name }}</b>
        </p>
    </div>

    <div class="d-flex mt-4 justify-content-center">
        <div class="c-ndarkfour d-flex align-items-center flex-column partner-option border bdc-nmidfour rounded mr-4 pointer"  @click="userType='pf'">
            <div class="icon-circle bgc-nlightone mb-4 mt-4 ">
                <User :size = "'24px'"/>
            </div>
            <el-radio :class="getPrimaryColor" v-model="userType" label="pf" >
                Pessoa Física
            </el-radio>
        </div>
    
        <div class="c-ndarkfour d-flex align-items-center flex-column partner-option border bdc-nmidfour rounded pointer"  @click="userType='pj'">
            <div class="icon-circle bgc-nlightone mb-4 mt-4">
                <Delivered :size = "'24px'"/>
            </div>
            <el-radio :class="getPrimaryColor" v-model="userType" label="pj">
                Pessoa Jurídica
            </el-radio>
        </div>
    </div>

    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
            Cancelar
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" @click="handleSelection">
            Selecionar
        </button>
    </span>
</el-dialog>
</template>

<script>
import User from '@/components/icons/User'
import FileWithWrite from '@/components/icons/FileWithWrite'
import Delivered from '@/components/icons/Delivered'

export default {
    components: {
       User,
       FileWithWrite,
       Delivered
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        partnerProfile: {
            type: String,
            default: 'pf'
        },
        changePartnerProfile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            userType: 'pf'
        }
    },
    watch: {
        partnerProfile(profile) {
            this.userType = profile
        }
    },
    methods: {
        handleSelection() {
            if (!this.changePartnerProfile) {
                this.$emit('closeModal', false)
                const routePrefix = this.$store.state.user.userAdm ? `/partner/${this.$route.params.idCNPJ}` : `/company/register/${this.$route.params.idCNPJ}/partner`
                this.$router.push(`${routePrefix}/${this.userType}/new`)
            } else {
                this.$emit('changePartnerProfile', this.userType)
            }
        },
        closeModal() {
            this.$emit('closeModal', false)
        },
    },
}
</script>

<style scoped>
    .icon-circle {
        height: 48px;
        width: 48px;    
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
    }
    .partner-option {
        height: 143px;
        width: 170px;
    }

    .icon-file {
        border-width: 3px !important;
    }

    .pointer {
        cursor: pointer;
    }
</style>